<template>
  <v-app v-if="pageSettings">
    <template v-if="!pageSettings.hideExhibitors">
      <exhibitor-view v-if="externalEventId"></exhibitor-view>
      <legacy-exhibitor-view v-else></legacy-exhibitor-view>
    </template>
    <webinar-view v-if="!pageSettings.hideWebinar"></webinar-view>
    <webinar-schedule-view
      v-if="!pageSettings.hideProgram"
    ></webinar-schedule-view>
    <sponsor-view v-if="!pageSettings.hideSponsors"></sponsor-view>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LegacyExhibitorView from "./components/LegacyExhibitorView";
import ExhibitorView from "./components/ExhibitorView";
import WebinarView from "./components/WebinarView";
import WebinarScheduleView from "./components/WebinarScheduleView";
import SponsorView from "./components/SponsorView";

export default {
  name: "App",
  components: {
    LegacyExhibitorView,
    ExhibitorView,
    WebinarView,
    WebinarScheduleView,
    SponsorView,
  },
  async created() {
    await Promise.all([this.getPageSettings(), this.getExecutiveProgramData()]);
    document.dispatchEvent(new CustomEvent("vue-loaded"));
  },
  methods: {
    ...mapActions(["getPageSettings", "getExecutiveProgramData"]),
  },
  computed: {
    ...mapGetters(["pageSettings", "externalEventId"]),
  },
};
</script>
